export default __webpack_public_path__ + "static/media/resume.bfe17942.PNG";